export default "/_nuxt/b7d622eccd3d544ec191f18101112fd7.svg";